// Mapa de categoria do cliente UPPERCASE (contrato do back) → label/tom do design.
// Mesmo padrão de `crm/utils/segment.ts`: o back guarda o enum maiúsculo, o design
// fala em label PT-BR + tom semântico, e isolar a tradução aqui evita espalhar
// `if tier === ...` pela UI.
//
// Categoria NÃO é segmento de CRM: o segmento é derivado por job (recência de
// compra), a categoria é atribuída à mão pelo gestor e tem vigência anual.
import type { BadgeVariant } from '@/components/ui/Badge';

export type CustomerTier = 'BRONZE' | 'PRATA' | 'OURO' | 'DIAMANTE';

export interface TierMeta {
  label: string;
  /** Variant do Badge primitivo (OCP: sem editar o Badge pra 4 cores novas). */
  variant: BadgeVariant;
  /** Cor CSS (var token) — usada em dot/borda onde o Badge não cabe. */
  color: string;
  desc: string;
}

export const TIER_META: Record<CustomerTier, TierMeta> = {
  BRONZE: {
    label: 'Bronze',
    variant: 'warning',
    color: 'var(--color-warning)',
    desc: 'Categoria de entrada. Cliente em construção de relacionamento com a loja.',
  },
  PRATA: {
    label: 'Prata',
    variant: 'gray',
    color: 'var(--color-text-subtle)',
    desc: 'Cliente recorrente já consolidado, acima da base de entrada.',
  },
  OURO: {
    label: 'Ouro',
    variant: 'info',
    color: 'var(--color-info)',
    desc: 'Cliente de alto valor. Prioridade no atendimento e nas condições comerciais.',
  },
  DIAMANTE: {
    label: 'Diamante',
    variant: 'purple',
    color: 'var(--ai-purple)',
    desc: 'Topo da base. Atendimento e benefícios diferenciados.',
  },
};

/** Ordem progressiva (entrada → topo) — seletor e legendas seguem esta ordem. */
export const TIER_ORDER: CustomerTier[] = ['BRONZE', 'PRATA', 'OURO', 'DIAMANTE'];

export function tierLabel(tier: CustomerTier): string {
  return TIER_META[tier].label;
}

export function tierBadgeVariant(tier: CustomerTier): BadgeVariant {
  return TIER_META[tier].variant;
}

export function tierColor(tier: CustomerTier): string {
  return TIER_META[tier].color;
}
